export default "__VITE_ASSET__54447f5c__"